//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_passCompute = 1.0;\n\
";
